import { render, staticRenderFns } from "./analysis-station.vue?vue&type=template&id=96dbaab0&scoped=true&"
import script from "./analysis-station.vue?vue&type=script&lang=js&"
export * from "./analysis-station.vue?vue&type=script&lang=js&"
import style0 from "./analysis-station.vue?vue&type=style&index=0&id=96dbaab0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96dbaab0",
  null
  
)

export default component.exports